import { ClientDTO } from "../DTO/clientDTO";
import { BasicRequest } from "./basicRequest";

export class CreateClientRequest extends BasicRequest{

    public customerId! : number;
    public client! : ClientDTO;
    
    constructor(){
        super();
    }
}